/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { InUserDTO, OutDetailUserDTO, OutUserDTO, UserEmailDTO, UserListResponseDTO } from "../models";
import {
  InUserDTOFromJSON,
  InUserDTOToJSON,
  OutDetailUserDTOFromJSON,
  OutDetailUserDTOToJSON,
  OutUserDTOFromJSON,
  OutUserDTOToJSON,
  UserEmailDTOFromJSON,
  UserEmailDTOToJSON,
  UserListResponseDTOFromJSON,
  UserListResponseDTOToJSON
} from "../models";

export interface CreateUserRequest {
  inUserDTO: InUserDTO;
}

export interface DeleteUserByUserIdRequest {
  userId: number;
}

export interface GetAllUsersExtendedRequest {
  take: number;
  skip: number;
  role?: string;
  searchQuery?: string;
}

export interface GetUserByIdRequest {
  userId: number;
}

export interface PatchUserEmailRequest {
  userId: number;
  userEmailDTO: UserEmailDTO;
}

export interface UpdateUserByIdRequest {
  userId: number;
  inUserDTO: InUserDTO;
}

/**
 *
 */
export class UsersApi extends runtime.BaseAPI {
  /**
   */
  async createUserRaw(
    requestParameters: CreateUserRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutUserDTO>> {
    if (requestParameters.inUserDTO === null || requestParameters.inUserDTO === undefined) {
      throw new runtime.RequiredError(
        "inUserDTO",
        "Required parameter requestParameters.inUserDTO was null or undefined when calling createUser."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/users`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: InUserDTOToJSON(requestParameters.inUserDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutUserDTOFromJSON(jsonValue));
  }

  /**
   */
  async createUser(
    requestParameters: CreateUserRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutUserDTO> {
    const response = await this.createUserRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async deleteUserByUserIdRaw(
    requestParameters: DeleteUserByUserIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters.userId === null || requestParameters.userId === undefined) {
      throw new runtime.RequiredError(
        "userId",
        "Required parameter requestParameters.userId was null or undefined when calling deleteUserByUserId."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/users/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<boolean>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   */
  async deleteUserByUserId(
    requestParameters: DeleteUserByUserIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<boolean> {
    const response = await this.deleteUserByUserIdRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getAllUsersExtendedRaw(
    requestParameters: GetAllUsersExtendedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UserListResponseDTO>> {
    if (requestParameters.take === null || requestParameters.take === undefined) {
      throw new runtime.RequiredError(
        "take",
        "Required parameter requestParameters.take was null or undefined when calling getAllUsersExtended."
      );
    }

    if (requestParameters.skip === null || requestParameters.skip === undefined) {
      throw new runtime.RequiredError(
        "skip",
        "Required parameter requestParameters.skip was null or undefined when calling getAllUsersExtended."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.take !== undefined) {
      queryParameters["take"] = requestParameters.take;
    }

    if (requestParameters.skip !== undefined) {
      queryParameters["skip"] = requestParameters.skip;
    }

    if (requestParameters.role !== undefined) {
      queryParameters["role"] = requestParameters.role;
    }

    if (requestParameters.searchQuery !== undefined) {
      queryParameters["searchQuery"] = requestParameters.searchQuery;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/users/extended`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => UserListResponseDTOFromJSON(jsonValue));
  }

  /**
   */
  async getAllUsersExtended(
    requestParameters: GetAllUsersExtendedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UserListResponseDTO> {
    const response = await this.getAllUsersExtendedRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getUserByIdRaw(
    requestParameters: GetUserByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutDetailUserDTO>> {
    if (requestParameters.userId === null || requestParameters.userId === undefined) {
      throw new runtime.RequiredError(
        "userId",
        "Required parameter requestParameters.userId was null or undefined when calling getUserById."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/users/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutDetailUserDTOFromJSON(jsonValue));
  }

  /**
   */
  async getUserById(
    requestParameters: GetUserByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutDetailUserDTO> {
    const response = await this.getUserByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async patchUserEmailRaw(
    requestParameters: PatchUserEmailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters.userId === null || requestParameters.userId === undefined) {
      throw new runtime.RequiredError(
        "userId",
        "Required parameter requestParameters.userId was null or undefined when calling patchUserEmail."
      );
    }

    if (requestParameters.userEmailDTO === null || requestParameters.userEmailDTO === undefined) {
      throw new runtime.RequiredError(
        "userEmailDTO",
        "Required parameter requestParameters.userEmailDTO was null or undefined when calling patchUserEmail."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/users/{userId}/email`.replace(
          `{${"userId"}}`,
          encodeURIComponent(String(requestParameters.userId))
        ),
        method: "PATCH",
        headers: headerParameters,
        query: queryParameters,
        body: UserEmailDTOToJSON(requestParameters.userEmailDTO)
      },
      initOverrides
    );

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<boolean>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   */
  async patchUserEmail(
    requestParameters: PatchUserEmailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<boolean> {
    const response = await this.patchUserEmailRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async updateUserByIdRaw(
    requestParameters: UpdateUserByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutDetailUserDTO>> {
    if (requestParameters.userId === null || requestParameters.userId === undefined) {
      throw new runtime.RequiredError(
        "userId",
        "Required parameter requestParameters.userId was null or undefined when calling updateUserById."
      );
    }

    if (requestParameters.inUserDTO === null || requestParameters.inUserDTO === undefined) {
      throw new runtime.RequiredError(
        "inUserDTO",
        "Required parameter requestParameters.inUserDTO was null or undefined when calling updateUserById."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/users/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: InUserDTOToJSON(requestParameters.inUserDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutDetailUserDTOFromJSON(jsonValue));
  }

  /**
   */
  async updateUserById(
    requestParameters: UpdateUserByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutDetailUserDTO> {
    const response = await this.updateUserByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
